import { gameCard as alpine } from './alpine/gameCard';
import { gameCard as egypt } from './egypt/gameCard';
import { gameCard as pixel } from './pixel/gameCard';
import type { Season } from './season';
import { gameCard as winter } from './winter/gameCard';
import { gameCard as halloween } from './halloween/gameCard';
import { gameCard as cherryBlossom } from './cherry-blossom/gameCard';

/** Mixed-season account cards load only their small, scoped card styles and artwork. */
export const gameCardArtwork: Record<Season, { left: string; right: string }> = {
  alpine,
  candy: halloween,
  egypt,
  pixel,
  winter,
  halloween,
  'cherry-blossom': cherryBlossom,
};
